import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from 'vue';
    import { Icon, Typo } from '@travelata-libs/ui-kit';
    import { useViewport } from '@travelata-libs/utils';
    import ConfirmationTypeIcon from './ConfirmationTypeIcon.vue';
    import ConfirmationTypeTooltip from './ConfirmationTypeTooltip.vue';
    import getConfirmationTypeName from '../lib/getConfirmationTypeName';
    import { ConfirmationType } from '../lib/types';
    import ConfirmationTypeModal from './ConfirmationTypeModal.vue';

    interface ConfirmationTypeIconProps {
        type?: ConfirmationType,
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationTypeInfo',
  props: {
    type: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { type: ConfirmationType }

    

    const { isMobile } = useViewport();

    const text = computed(() => getConfirmationTypeName(props.type));

    const additionalsComponent = computed(() => isMobile.value ? ConfirmationTypeModal : ConfirmationTypeTooltip);


return { __sfc: true,props, isMobile, text, additionalsComponent, Icon, Typo, ConfirmationTypeIcon, ConfirmationType }
}

})